import(/* webpackMode: "eager" */ "/vercel/path0/packages/web/app/stats/page.tsx");
